import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import ScreensPersonForm from './Form/ScreensPersonForm';
import ScreensPersonList from './List/ScreensPersonList';
import ScreensPersonLinked from './Linked/ScreensPersonLinked';

function ScreensPerson() {
  return (
    <Routes>
      <Route
        path="/create"
        element={
          <RoutePrivate
            element={ScreensPersonForm}
            requiredPermission="persons.create"
          />
        }
      />
      <Route
        path="/:id/edit"
        element={
          <RoutePrivate
            element={ScreensPersonForm}
            requiredPermission="persons.update"
          />
        }
      />
      <Route
        path="/:id/linked"
        element={
          <RoutePrivate
            element={ScreensPersonLinked}
            requiredPermission="persons.update"
          />
        }
      />
      <Route
        path="/list"
        element={
          <RoutePrivate
            element={ScreensPersonList}
            requiredPermission="persons.update"
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/people/list" />} />
    </Routes>
  );
}

export default ScreensPerson;
